import React, {useState, useEffect} from 'react';
import {Link} from "react-router-dom"
import Api from '../servicios/api';
import {Header, Titulo, ContenedorHeader, ContenedorBotones} from '../elementos/Header'
import {ContenedorBotonesLista, BotonEditar, BotonEliminar, Buscador, ContenedorBuscador, InputBuscador} from '../elementos/ElementosDeLista'
import {ReactComponent as IconoEditar} from '../imagenes/editar.svg'
import {ReactComponent as IconoBorrar} from '../imagenes/borrar.svg'
import { FaSearch } from "react-icons/fa";
import Boton from '../elementos/Boton'
import Alerta from '../elementos/Alerta'
import Cargando from '../elementos/Cargando'
import VentanaModal from '../elementos/VentanaModal'


const ListarObjetos = () => {
    const [datosCargados, setdatosCargados] = useState(false);
    const [objetos, setObjeto] = useState([]);
    const [estadoAlerta, setEstadoAlerta] = useState(false);
    const [alerta, setAlerta] = useState({});
    const [modal, setModal] = useState({});
    const [estadoModal, setEstadoModal] = useState(false);
    const [idEliminar, setidEliminar] = useState();
    const [buscador, setBuscador] = useState();

    //Este hook se ejecuta solamente al primer renderizado
    useEffect(() => {
        cargarDatos();
    }, [buscador]);

    const cargarDatos = () => {
        var datosEnviar;

        if(buscador){
            datosEnviar = {busqueda: buscador}
        }

        fetch(Api+"?consultarObjetos",{
            method:"POST",
            body:JSON.stringify(datosEnviar)
        })
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setdatosCargados(true);
            setObjeto(datosRespuesta);
        })
        .catch(console.log)
        
    }

    const handleChange = (e) => {
        switch(e.target.name){
            case 'buscador':
                setBuscador(e.target.value);
                break;
            default:
                break;
        }
    }

    const handleModal = (id) => {
        setidEliminar(id);
        setEstadoModal(true);
        setModal({
            header: 'Eliminar Solicitud',
            body: '¿Está seguro de eliminar el objeto?'
        });
    }

    const borrarRegistro = ()=> {
        setEstadoModal(false);
        setEstadoAlerta(false);
        setAlerta({});
        
        fetch(Api+"?borrarObjeto="+idEliminar)
        .then(respuesta=>respuesta.json())
        .then((datosRespuesta)=>{
            setEstadoAlerta(true);
            setAlerta({
                tipo: 'exito',
                mensaje: 'Objeto eliminado correctamente.'
            });
            cargarDatos();
        })
        .catch(console.log)
    }

    if(!datosCargados){
        return(
            <Cargando />
        );
    }
    else{
        return (
            <>
                <Header>
                    <ContenedorHeader>
                        <Titulo>Lista de Objetos</Titulo>
                        <ContenedorBotones>
                            <Boton to="/crear-objeto" primario="true">Agregar Objeto</Boton>
                        </ContenedorBotones>
                    </ContenedorHeader>
                </Header>

                <Buscador>
                    <ContenedorBuscador>
                        <InputBuscador
                            type="text"
                            name="buscador"
                            placeholder="Ingrese código, nombre de material o cultura"
                            value={buscador}
                            onChange={handleChange}
                        />
                        <i className='icono-buscador'><FaSearch /></i> 
                    </ContenedorBuscador>
                </Buscador>

                <div className="contenedor-tabla">
                    <div className="card card-tamano card-tamano-busqueda">
                        <div className="card-body card-body-tamano">
                            <table className="table table-striped justificar-fila" id="example">
                                <thead>
                                    <tr>
                                        <th>Código</th>
                                        <th>Descripción</th>
                                        <th>Estado</th>
                                        <th>Ubicación</th>
                                        <th>Material</th>
                                        <th>Cultura</th>
                                        <th>% de Integridad</th>
                                        <th>% de Conservación</th>
                                        <th>Observaciones</th>
                                        <th>Ruta Imagen</th>
                                        <th>Acciones</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        objetos.success !== 0 &&
                                            objetos.map(
                                                (objeto)=>(
                                                    <tr key={objeto.Obj_ID}>
                                                        <td>{objeto.Obj_CodigoActual}</td>
                                                        <td>{objeto.Obj_Descripcion}</td>
                                                        <td>{objeto.Obj_Estado}</td>
                                                        <td>{objeto.Ubi_Nombre}</td>
                                                        <td>{objeto.Mat_Nombre}</td>
                                                        <td>{objeto.Cul_Nombre}</td>
                                                        <td>{objeto.Obj_PorcIntegridad}%</td>
                                                        <td>{objeto.Obj_PorcConservacion}%</td>
                                                        <td>{objeto.Obj_Observaciones}</td>
                                                        <td>{objeto.Obj_RutaImagen}</td>
                                                        <td>
                                                            <ContenedorBotonesLista>
                                                                <BotonEditar title="Actualizar Objeto" as={Link} to={"/editar-objeto/"+objeto.Obj_ID}>
                                                                    <IconoEditar />
                                                                </BotonEditar>
                                                                
                                                                <BotonEliminar title="Eliminar Objeto" onClick={() => handleModal(objeto.Obj_ID)}>
                                                                    <IconoBorrar />
                                                                </BotonEliminar>
                                                            </ContenedorBotonesLista>
                                                        </td>
                                                    </tr>
                                                )
                                            )
                                    }              
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
                
                
                <Alerta 
                        tipo={alerta.tipo}
                        mensaje={alerta.mensaje}
                        estadoAlerta={estadoAlerta}
                        setEstadoAlerta={setEstadoAlerta}
                />

                <VentanaModal
                        mensajeHeader={modal.header}
                        mensajeBody={modal.body}
                        estadoModal={estadoModal}
                        setEstadoModal={setEstadoModal}
                        handleConfirm={borrarRegistro}
                />
            </>
        );
    }
}

export default ListarObjetos;